export default __webpack_public_path__ + "static/media/now-hiring.3887f7cc.png";